export default __webpack_public_path__ + "static/media/checked.1a9e5830.svg";